import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import {
  createGroup,
  deleteGroup,
  getGroupList,
  updateGroup,
} from "../../../../redux/reducers/groupSlice";
import { AppColors } from "../../../../util/AppColors";
import { tblGrayBack } from "../../../../util/object";

function Group({ onGroupClick }) {
  const dispatch = useDispatch();
  const fetchRef = useRef(false);
  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ groupName: "" });
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const groupList = useSelector((state) => state.group.list);
  const { selectedClinicBranch } = useSelector((state) => state?.clinic);
  const role = localStorage.getItem("role");

  useEffect(() => {
    if (fetchRef.current) return;
    if (role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      fetchRef.current = true;
      const reqUrl = `?clinicId=${selectedClinicBranch?.branchId}`;
      onApiCall(reqUrl);
      return;
    }
    fetchRef.current = true;
    onApiCall();
  }, [selectedClinicBranch, role, dispatch]);

  const onApiCall = (url = "") => {
    dispatch(getGroupList(url));
  };

  const handleAddOrUpdate = () => {
    if (!form.groupName) return;
    if (editIndex !== null) {
      const group = groupList[editIndex];
      dispatch(
        updateGroup({ groupId: group.roomId, groupName: form.groupName }),
      ).then(() => {
        onApiCall(
          role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
            ? `?clinicId=${selectedClinicBranch?.branchId}`
            : null,
        );
      });
    } else {
      dispatch(createGroup(form)).then(() => {
        onApiCall(
          role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
            ? `?clinicId=${selectedClinicBranch?.branchId}`
            : null,
        );
      });
    }
    handleCloseDrawer();
  };

  const handleEdit = (index) => {
    const group = groupList[index];
    setForm({ groupName: group.groupName });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    dispatch(deleteGroup({ groupId: deleteId })).then(() => {
      setDelModVisible(false);
      setDeleteId(null);
    });
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteId(null);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setForm({ groupName: "" });
    setEditIndex(null);
  };

  const filteredRows = [...groupList]
    .filter((row) => row.groupName.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

  return (
    <Box
    // p={3}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        // mt={2}
        flexWrap="wrap"
      >
        <Box
          display="flex"
          gap={2}
          mx="auto"
          // mb={2}
        >
          <div style={{ width: "500px" }}>
            <CustomTextField
              placeholder="Search"
              fullWidth
              backgroundColor={AppColors.lightBlue2}
              value={search}
              handleChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {/* <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          /> */}
          <Button variant="contained" onClick={() => setOpenDrawer(true)}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Groups: {filteredRows.length}
        </Typography>
      </Box>

      <Box sx={{ mt: 2, maxHeight: "60vh", overflowY: "auto" }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  "S.No",
                  "Group Name",
                  "Created By",
                  "Created Date",
                  "Actions",
                ].map((li, i) => (
                  <TableCell
                    style={tblGrayBack}
                    className="txt-semi-bold fs12"
                    key={i + li}
                  >
                    {li}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((row, index) => (
                  <TableRow key={row.roomId}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Typography
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        onClick={() => onGroupClick(row.roomId, row.groupName)}
                      >
                        {row.groupName}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.userName || "-"}</TableCell>
                    <TableCell>
                      {new Date(row.createdDate).toLocaleDateString()}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => handleEdit(index)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleDeleteClick(row.roomId)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Drawer anchor="right" open={openDrawer} onClose={handleCloseDrawer}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Group" : "Create Group"}
            </Typography>
            <IconButton onClick={handleCloseDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Group Name"
            value={form.groupName}
            onChange={(e) => setForm({ ...form, groupName: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Group;
